import Swiper from 'swiper/bundle'
/**
 * LogosSlider component.
 * @author Dayne Coulson-Hoffacker
 */
export default class LogosSlider {
  /**
   * Constructs a new LogosSlider component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')

    const logosSlider = new Swiper(this.swiperElement, {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 30,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
    })
  }
}
